module.exports = __webpack_public_path__ + "static/media/seeAttachedDoc.c3ba91e1.svg";